import Alpine from 'alpinejs';
import MicroModal from 'micromodal';

window.Alpine = Alpine;
Alpine.start();

window.isAModalClose = true;

// there is a bug where MicroModal will discard the config after the first open,
// so store it here and pass it each time a modal is opened.
const MicroModalConfig = {
    disableScroll: true,
    onShow: (modal) => {
        modal.scrollTop = 0;
        modal.querySelectorAll('*').forEach((el) => {
            el.scrollTop = 0;
        });
        document.activeElement.blur();

        setTimeout(() => {
            modal.scrollTop = 0;
            modal.querySelectorAll('*').forEach((el) => {
                el.scrollTop = 0;
            });
            document.activeElement.blur();
        }, 50);
    },
    onClose: (modal) => {
        setTimeout(() => {
            if (!window.isAModalClose) {
                console.log('Not exactly a Close');
            }
            if (window.isAModalClose) {
                console.log(modal.id);
                // Set Modal Close GA for Pop up & Newsletter
                const eventName = modal.id == 'modal-auto' ? 'popup_close' : (modal.id == 'newsletter-signup' ? 'newsletter_signup_close' : false);
                const newsletterName = modal.classList.contains('sdn') ? 'SDN' : 'QT';

                // Only send on modal-auto and newsletter-signup
                if (eventName && newsletterName) {
                    // Send to GTM / GA (Close)
                    window.dataLayer = window.dataLayer || [];
                    dataLayer.push({
                        event: eventName,
                        newsletter: newsletterName,
                        source: 'auto',
                    });
                }

                if (['newsletter-signup-thanks', 'newsletter-signup'].includes(modal.id)) {
                    console.log('Turning off timer');

                    dataLayer.push({
                        event: 'page_view',
                        page_title: document.title,
                        ...window.getUTMParameters(),
                    });
                }
            }
            window.isAModalClose = true;
        }, 100);
    },
};

MicroModal.init(MicroModalConfig);

window.MicroModal = MicroModal;
window.MicroModalConfig = MicroModalConfig;

/**
 * Close the modal auto and open the newsletter modal
 */
window.qmModalAutoToNewsletter = function (newsletterName) {
    window.isAModalClose = false;
    console.log('Close the modal auto', window.MicroModalConfig);
    MicroModal.close('modal-auto');
    console.log('Open the newsletter modal');
    MicroModal.show('newsletter-signup', window.MicroModalConfig);

    window.setNewsletterVisitGA(newsletterName, 'Pop-up');
};

/**
 * Set GA for visit and unique visit
 */
window.setNewsletterVisitGA = function (newsletterName, sourceName = 'auto') {
    const utmData = window.getUTMParameters();

    // Send to GTM / GA (Visit)
    window.dataLayer = window.dataLayer || [];
    dataLayer.push({
        event: 'newsletter_signup_show',
        newsletter: newsletterName,
        source: setSourceName(sourceName),
        ...utmData,
    });

    // Send to GTM / GA (Unique visit)
    const gaUniqueCookie = `unique_${newsletterName}_visit`;
    if (document.cookie.indexOf(gaUniqueCookie) === -1) {
        window.setPopupCookie(gaUniqueCookie);

        dataLayer.push({
            event: 'newsletter_signup_unique_show',
            newsletter: newsletterName,
            source: setSourceName(sourceName),
            ...utmData,
        });
    }

    // Send newsletter time period
    dataLayer.push({
        event: 'page_view',
        page_title: `${newsletterName} Newsletter`,
        ...utmData,
    });
};

/**
 * Set cookie
 */
window.setPopupCookie = function (cname) {
    const d = new Date();
    const expiresInDays = 7; // Expiry in days
    const cvalue = '1'; // Value but not important
    d.setTime(d.getTime() + (expiresInDays * 24 * 60 * 60 * 1000));
    const expires = `expires=${d.toUTCString()}`;
    document.cookie = `${cname}=${cvalue};${expires}`;
};

/**
 * Set Source Name
 */
const setSourceName = function (sourceName) {
    switch (sourceName) {
    case '':
        return 'Homepage';
    default:
        return sourceName;
    }
};

/**
 *
 */
window.getUTMParameters = function () {
    const params = new URLSearchParams(window.location.search);
    const utmParams = {};
    const utmKeys = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'];
    utmKeys.forEach((key) => {
        if (params.has(key)) {
            utmParams[key] = params.get(key);
        }
    });
    return utmParams;
};

global.quietmark = {}; // for packages used across required modules

global.quietmark.video = require('./modules/video');
global.quietmark.inView = require('in-view');
global.quietmark.supportsPassive = require('./polyfills/supports-passive');
global.quietmark.truncate = require('./modules/truncate');
global.quietmark.revealer = require('./modules/revealer');

require('tocca'); // tap events

window.tocca({
    tapThreshold: 80,
    justTouchEvents: true,
});

require('./polyfills/foreach');

require('./bootstrap');
require('./modules/custom-properties');
require('./modules/menu');
require('./modules/sliders');
require('./modules/product-sliders');
require('./modules/news-sliders');
require('./modules/info-sliders');
require('./modules/building-card-sliders');
require('./modules/progress-rings');
require('./modules/t-transition');
require('./modules/tabs');
require('./modules/top-nav-peek');
require('./modules/filter-checkbox');
require('./modules/load-more');
require('./modules/mobile-breadcrumbs');
require('./modules/video-lightbox-link');
require('./modules/case-study-lightbox-link');
require('./modules/mega-dropdowns');
require('./modules/modal-auto');
require('./modules/all-brands-popup');
require('./modules/fittext');
require('./modules/pop-newsletter');
require('./modules/datalayer');
